<div class="pill split-pill">
  <span
    class="split-pill-side split-pill-left"
    (click)="!loading && navigateOlder()"
    [class.disabled]="loading"
    title="View older data">
    <i class="fa-regular fa-chevron-left"></i>
    <span class="pill-label">Older</span>
  </span>
  <span
    class="split-pill-side split-pill-right"
    (click)="!loading && !isAtLatest && navigateNewer()"
    [class.disabled]="loading || isAtLatest"
    title="View newer data">
    <span class="pill-label">Newer</span>
    <i class="fa-regular fa-chevron-right"></i>
  </span>
</div>

<div class="picker-anchor">
  <button class="control-pill" (click)="stepSelectorOpen = !stepSelectorOpen; $event.stopPropagation()">
    <i class="fa-regular fa-ruler"></i>
    {{ stepPillText }}
  </button>
  @if (stepSelectorOpen) {
    <motn-popover-menu
      [optionGroup]="stepOptions"
      [overlayPositions]="popoverPositions"
      (clickedOption$)="onStepChange($event)"
      (clickedOutsideMenu$)="stepSelectorOpen = false"
    ></motn-popover-menu>
  }
  @if (customStepDialogOpen) {
    <motn-custom-step-picker
      [value]="customStepValue"
      [unit]="customStepUnit"
      (valueChange)="onCustomStepChange($event)"
      (unitChange)="customStepUnit = $event"
      (closed$)="customStepDialogOpen = false"
    ></motn-custom-step-picker>
  }
</div>

<div class="picker-anchor">
  <button class="control-pill" (click)="dateTimeMenuOpen = !dateTimeMenuOpen; $event.stopPropagation()">
    <i class="fa-regular fa-clock"></i>
    {{ dateTimePillText }}
  </button>
  @if (dateTimeMenuOpen) {
    <motn-popover-menu
      [optionGroup]="dateTimeOptions"
      [overlayPositions]="popoverPositions"
      (clickedOption$)="dateTimeMenuOpen = false"
      (clickedOutsideMenu$)="dateTimeMenuOpen = false"
    ></motn-popover-menu>
  }
  @if (datePickerOpen) {
    <motn-datetime-picker
      [value]="selectedDatetime"
      (valueChange)="onDateTimeChange($event)"
      (closed$)="datePickerOpen = false"
    ></motn-datetime-picker>
  }
</div>
